import { BookOpenIcon } from "lucide-react";

export function LessonCardSkeleton() {
  return (
    <section>
      <div className="mb-6 flex items-center gap-2 border-b border-gray-200 pb-3 dark:border-gray-700">
        <div className="h-6 w-6 animate-pulse rounded-full bg-gray-200 dark:bg-gray-700" />
        <div className="h-8 w-48 animate-pulse rounded bg-gray-200 dark:bg-gray-700" />
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
        {Array.from({ length: 3 }).map((_, index) => (
          <div
            key={index}
            className="overflow-hidden rounded-2xl border border-gray-100 bg-white dark:border-gray-700 dark:bg-gray-800"
          >
            {/* Image skeleton */}
            <div className="aspect-video w-full animate-pulse bg-gray-200 dark:bg-gray-700" />

            {/* Content skeleton */}
            <div className="p-6">
              <div className="mb-3 h-5 w-3/4 animate-pulse rounded bg-gray-200 dark:bg-gray-700" />
              <div className="mb-4 h-4 w-full animate-pulse rounded bg-gray-200 dark:bg-gray-700" />
              <div className="mb-4 h-4 w-2/3 animate-pulse rounded bg-gray-200 dark:bg-gray-700" />

              {/* Stats skeleton */}
              <div className="flex items-center gap-4">
                <div className="flex items-center gap-2">
                  <BookOpenIcon className="h-4 w-4 text-gray-300 dark:text-gray-600" />
                  <div className="h-3 w-8 animate-pulse rounded bg-gray-200 dark:bg-gray-700" />
                </div>
                <div className="flex items-center gap-2">
                  <div className="h-4 w-4 animate-pulse rounded-full bg-gray-200 dark:bg-gray-700" />
                  <div className="h-3 w-8 animate-pulse rounded bg-gray-200 dark:bg-gray-700" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
